import 'babel-polyfill'
import './polyfills/CustomEvent'
import './polyfills/NodeList'
import Vue from 'vue'
import App from '@/App.vue'
import SocialSharing from 'vue-social-sharing'
import Clipboard from 'v-clipboard'


Vue.use(SocialSharing)
Vue.use(Clipboard)
Vue.config.productionTip = false

var vm = new Vue({
  render: h => h(App)
}).$mount('#shareWidget')


 $(document).on('click', '.button-share', function (e) {


   var currentShareButton = $(e.target)
   var sharebox = $('#shareWidget')

   console.log($(e)[0].currentTarget)

   if ($(e)[0].currentTarget.classList.contains('button-share--private')) {
     window.isPrivate = true;
   } else {
     window.isPrivate = false;
   }

   //STORE DATA
   window.titleShare = currentShareButton.closest('.boxArticle').find('.title').text().trim()
   window.urlShare = currentShareButton.closest('.boxArticle').find('.title a').attr("href")
   window.quoteShare = currentShareButton.closest('.boxArticle').find('.title').text().trim()
   window.twitterHashtag = "BNPPF"
   
 
    var positionTopShareButton = currentShareButton.offset().top
    window.positionLeftShareButton = currentShareButton.offset().left

    setTimeout(() => {
      sharebox.css('top', positionTopShareButton)
      vm.$children[0].storeData()
    }, 500)
    

 })